import axios from "../../privateApi";

export const trackReactivateSubscription = () => {
  return axios.post("/event-tracking/reactivate-subscription");
};
